import React, { useState } from "react"
import { Button, Dropdown, DropdownMenu, DropdownToggle, Form, FormGroup, Input } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown, faChevronUp, faThumbsUp } from "@fortawesome/free-solid-svg-icons"
import TraindexApi from "../../api/TraindexAPI"

const Feedback = () => {
  const [feedback, setFeedback] = useState(""),
    [isPositive, setIsPositive] = useState(),
    [feedbackDDOpen, setFeedbackDDOpen] = useState(false)

  const handleFeedback = async () => {
    setIsPositive()
    setFeedback("")
    await TraindexApi.handleFeedback({
      intent: isPositive || false,
      userFeedback: feedback,
    })
  }

  const toggleFeedbackDD = () => setFeedbackDDOpen((prev) => !prev)

  return (
    <Dropdown isOpen={feedbackDDOpen} toggle={toggleFeedbackDD}>
      <DropdownToggle color="primary" outline className="w-100 d-flex align-items-center justify-content-between">
        <FontAwesomeIcon icon={faThumbsUp} size="xs" className="px-1" />
        Provide Feedback
        {feedbackDDOpen ? (
          <FontAwesomeIcon icon={faChevronUp} size="xs" className="px-1" />
        ) : (
          <FontAwesomeIcon icon={faChevronDown} size="xs" className="px-1" />
        )}
      </DropdownToggle>
      <DropdownMenu className="p-2 mt-2">
        <p style={{ whiteSpace: "pre-line" }}>Please provide your valuable feedback to help us improve</p>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <p className="m-0">Helpful?</p>
          <div className="d-flex align-items-center col-4 col-md-10">
            <div className="d-flex justify-content-end thumb" color="primary" onClick={() => setIsPositive(true)}>
              {isPositive == true ? (
                <img src="/like-solid.png" alt="dislike" className="w-icon-25 px-1" />
              ) : (
                <img src="/like.png" alt="like" className="w-icon-25 px-1" />
              )}
            </div>
            <div className="d-flex justify-content-start thumb" color="primary" onClick={() => setIsPositive(false)}>
              {isPositive == false ? (
                <img src="/dislike-solid.png" alt="dislike" className="w-icon-25 px-1" />
              ) : (
                <img src="/dislike.png" alt="dislike" className="w-icon-25 px-1" />
              )}
            </div>
          </div>
        </div>
        <Form>
          <FormGroup className="d-flex flex-column mb-0">
            <Input
              type="textarea"
              placeholder="Feedback"
              value={feedback}
              onChange={(event) => setFeedback(event.target.value)}
              className="mb-2"
            />
            <Button color="primary" onClick={() => handleFeedback()}>
              Submit
            </Button>
          </FormGroup>
        </Form>
      </DropdownMenu>
    </Dropdown>
  )
}
export default Feedback
